module.exports = __webpack_public_path__ + "img/1582590926.4ac14906.jpg";